import { useFilesEuerQuery } from "../../../../../../../api/graphql/queries/euerDeclaration/filesEuer.generated";

type Params = {
  email: string | null | undefined;
  skip?: boolean;
};

/**
 * Whether the backend says an EÜR is filed for this customer (false for a
 * corporation, where the EÜR is for the plausibility check only). The rule
 * lives in the backend; the Backoffice only asks. Fail-open: while loading,
 * on error or without an answer this reports `true`, so no hint is shown that
 * we cannot back up. `network-only` so a legal form change shows on the next
 * page load.
 */
const useFilesEuer = ({ email, skip }: Params) => {
  const { data, loading } = useFilesEuerQuery({
    skip: skip || !email,
    fetchPolicy: "network-only",
    variables: { email: email! },
  });

  return { filesEuer: data?.filesEuer ?? true, loading };
};

export default useFilesEuer;
